import clsx from 'clsx';

import { renderIcon } from '../util';
import type { BadgeProps } from './Badge';
import styles from './Badge.module.css';

/**
 * BadgeContent is the base component to render the content of a badge.
 */
export function BadgeContent(
    props: Pick<BadgeProps, 'icon' | 'label' | 'size'> & {
        isIconOnly: boolean;
        isNumber: boolean;
        iconSize: number;
    }
) {
    const { icon, label, size, iconSize, isIconOnly, isNumber } = props;

    return (
        <>
            {icon
                ? renderIcon(icon, {
                      size: iconSize,
                      className: 'shrink-0',
                  })
                : null}
            {!isIconOnly ? (
                <span
                    className={clsx('shrink-0 text-nowrap', isNumber && styles.numberLabel, {
                        'text-ui-action': size === 'medium',
                        'text-ui-small': !size || ['xsmall', 'small'].includes(size),
                    })}
                >
                    {label}
                </span>
            ) : null}
        </>
    );
}
